import React from 'react'

const UPDashboard = () => {
  return (
    <iframe className='w-full h-full' src='https://crop-analytics.agrani.io' />
  )
}

export default UPDashboard